import { useIsOnboardingTour } from "@-/dev.improve.haniverse.lib.onboarding";
import { CHINA_MAP_SHEET_HEIGHTS } from "#china-map-sheet-heights";

/**
 * The greeting's opening height is synchronous, including before travel or study data exists.
 * During onboarding its own sheet occupies this space instead.
 */
export function useChinaMapOpeningSheetHeight(): number {
  const isOnboardingTour = useIsOnboardingTour();
  return CHINA_MAP_SHEET_HEIGHTS[isOnboardingTour ? "peek" : "home"];
}
